/**
 * Formats a phone number string to display as (XXX) XXX XXXX
 * @param {string} value - The phone number string to format
 * @returns {string} - The formatted phone number
 */
export const formatPhoneNumber = (value) => {
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, '');

  // Don't format if empty
  if (!phoneNumber) return '';

  // Don't format if more than 10 digits
  if (phoneNumber.length > 10) {
    return phoneNumber
      .slice(0, 10)
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 $3');
  }

  // Format based on length
  if (phoneNumber.length <= 3) {
    return `(${phoneNumber}`;
  } else if (phoneNumber.length <= 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  } else {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 10)}`;
  }
};

/**
 * Removes formatting from a phone number string
 * @param {string} formattedPhone - The formatted phone number string
 * @returns {string} - The unformatted phone number (digits only)
 */
export const unformatPhoneNumber = (formattedPhone) => {
  return formattedPhone.replace(/\D/g, '');
};
